import { motion } from 'motion/react';

interface CurtainRevealEntryProps {
  children: React.ReactNode;
  threshold?: number;
  delay?: number;
}

export function CurtainRevealEntry({ children, threshold = 0.3, delay = 1.7 }: CurtainRevealEntryProps) {
  return (
    <motion.div className="relative overflow-hidden">
      {/* Left curtain */}
      <motion.div
        initial={{ x: '-100%' }}
        whileInView={{ x: 0 }}
        viewport={{ once: true, amount: threshold }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
        className="absolute left-0 top-0 bottom-0 w-1/2 bg-gradient-to-r from-gray-900 to-transparent z-10 pointer-events-none"
      />

      {/* Right curtain */}
      <motion.div
        initial={{ x: '100%' }}
        whileInView={{ x: 0 }}
        viewport={{ once: true, amount: threshold }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
        className="absolute right-0 top-0 bottom-0 w-1/2 bg-gradient-to-l from-gray-900 to-transparent z-10 pointer-events-none"
      />

      {/* Content reveals after background artwork display duration */}
      <motion.div
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: threshold }}
        transition={{ duration: 1.2, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </motion.div>
  );
}
